import { InputNumber } from "antd"
import style from "./PriceSection.module.scss"

const { section, labelRow, label, requiredMark, numberInput } = style

type Props = {
	value: number | null
	onChange: (value: number | null) => void
	onBlur?: () => void
	/** `Mixed` in the batch panel (REQ-403), where the selected objects hold different prices. */
	placeholder?: string
}

export const PriceSection = ({ value, onChange, onBlur, placeholder }: Props) => {
	return (
		<div className={section}>
			<div className={labelRow}>
				<span className={label}>Price</span>
				<span className={requiredMark}>*</span>
			</div>
			<InputNumber
				className={numberInput}
				value={value}
				// Rounded to cents on the way out: both fixed-price endpoints accept at most 2 decimal
				// places, so a typed `12.345` could only be rejected — and in the batch panel that
				// rejection covers every selected object. Done here rather than with antd's
				// `precision={2}`, which would also PAD the display and turn a stored `123` into
				// `123.00` in the single-object sidebar.
				onChange={(v) => onChange(typeof v === "number" ? Math.round(v * 100) / 100 : null)}
				onBlur={onBlur}
				placeholder={placeholder}
				prefix="$"
				controls={false}
				min={0}
			/>
		</div>
	)
}
